import { PriorityType, ProgressType } from "./types";
import { getPalette } from "../../../configuration/configuration";
import StopIcon from "@mui/icons-material/Stop";
import StartIcon from "@mui/icons-material/Start";
import PauseIcon from "@mui/icons-material/Pause";
import BlockIcon from "@mui/icons-material/Block";
import DoneIcon from "@mui/icons-material/Done";
import FlagIcon from "@mui/icons-material/Flag";
import { ReactElement } from "react";

export const getProgressText = (value: ProgressType): string => {
  switch (value) {
    case ProgressType.InProgress:
      return "In Progress";
    case ProgressType.Completed:
      return "Completed";
    case ProgressType.OnHold:
      return "On Hold";
    case ProgressType.Cancelled:
      return "Cancelled";
    default:
      return "Pending";
  }
};

export const getProgressValue = (value: string): ProgressType => {
  switch (value) {
    case "In Progress":
      return ProgressType.InProgress;
    case "Completed":
      return ProgressType.Completed;
    case "On Hold":
      return ProgressType.OnHold;
    case "Cancelled":
      return ProgressType.Cancelled;
    default:
      return ProgressType.Pending;
  }
};

// const charts = {
//   "red": "#ef5350",
//   "pink": "#ec407a",
//   "purple": "#ab47bc",
//   "deepPurple": "#7e57c2",
//   "indigo": "#5c6bc0",
//   "blue": "#42a5f5",
//   "lightBlue": "#29b6f6",
//   "cyan": "#26c6da",
//   "teal": "#26a69a",
//   "green": "#66bb6a",
//   "lightGreen": "#9ccc65",
//   "lime": "#d4e157",
//   "yellow": "#ffee58",
//   "amber": "#ffca28",
//   "orange": "#ffa726",
//   "deepOrange": "#ff7043",
//   "gray": "#616161"
// };

export const getProgressColor = (value: ProgressType): string => {
  switch (value) {
    case ProgressType.InProgress:
      return getPalette().charts.blue;
    case ProgressType.Completed:
      return getPalette().charts.green;
    case ProgressType.OnHold:
      return getPalette().charts.orange;
    case ProgressType.Cancelled:
      return getPalette().charts.red;
    default:
      return getPalette().charts.gray;
  }
};

interface IProgressIconProps {
  progress: ProgressType;
}

export const ProgressIcon = ( { progress }: IProgressIconProps): ReactElement => {
  switch (progress) {
    case ProgressType.InProgress:
      return <StartIcon style={{ color: getProgressColor(progress) }}/>;
    case ProgressType.Completed:
      return <DoneIcon style={{ color: getProgressColor(progress) }}/>;
    case ProgressType.OnHold:
      return <PauseIcon style={{ color: getProgressColor(progress) }}/>;
    case ProgressType.Cancelled:
      return <BlockIcon style={{ color: getProgressColor(progress) }}/>;
    default:
      return <StopIcon style={{ color: getProgressColor(progress) }}/>;
  }
};

export const getPriorityText = (value: PriorityType): string => {
  switch (value) {
    case PriorityType.Important:
      return "Important";
    case PriorityType.Urgent:
      return "Urgent";
    case PriorityType.Medium:
      return "Medium";
    default:
      return "Low";
  }
};

export const getPriorityValue = (value: string): PriorityType => {
  switch (value) {
    case "Important":
      return PriorityType.Important;
    case "Urgent":
      return PriorityType.Urgent;
    case "Medium":
      return PriorityType.Medium;
    default:
      return PriorityType.Low;
  }
};

export const getPriorityColor = (value: PriorityType): string => {
  switch (value) {
    case PriorityType.Important:
      return getPalette().charts.orange;
    case PriorityType.Urgent:
      return getPalette().charts.red;
    case PriorityType.Medium:
      return getPalette().charts.lime;
    default:
      return getPalette().charts.gray;
  }
};


interface IPriorityIconProps {
  priority: PriorityType;
}

export const PriorityIcon = ({ priority }: IPriorityIconProps): ReactElement => {
  switch (priority) {
    case PriorityType.Important:
      return <FlagIcon style={{ color: getPriorityColor(priority) }}/>;
    case PriorityType.Urgent:
      return <FlagIcon style={{ color: getPriorityColor(priority) }}/>;
    case PriorityType.Medium:
      return <FlagIcon style={{ color: getPriorityColor(priority) }}/>;
    default:
      return <FlagIcon style={{ color: getPriorityColor(priority) }}/>;
  }
};

